import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import styles from '../styles/Header.module.css';
import logo from '../assets/hodson_logo_3.png';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        {/* Logo */}
        <img src={logo} alt="Hodson Timber" className={styles.logo} />

        {/* Desktop navigation */}
        <nav className={styles.desktopNav}>
          <Link to="/">Home</Link>
          <Link to="/about">About Us</Link>
          <Link to="/services">What We Do</Link>
          <Link to="/materials-craftsmanship">Materials</Link>
          <Link to="/our-work">Our Work</Link>
          <Link to="/workshop">Workshop</Link>
          <Link to="/contact">Contact</Link>
        </nav>

        {/* Burger button */}
        <button
          className={styles.burger}
          onClick={toggleMenu}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <nav className={styles.mobileNav}>
          <Link to="/" onClick={closeMenu}>
            Home
          </Link>
          <Link to="/about" onClick={closeMenu}>
            About Us
          </Link>
          <Link to="/services" onClick={closeMenu}>
            What We Do
          </Link>
          <Link to="/materials-craftsmanship" onClick={closeMenu}>
            Materials
          </Link>
          <Link to="/our-work" onClick={closeMenu}>
            Our Work
          </Link>
          <Link to="/workshop" onClick={closeMenu}>
            Workshop
          </Link>
          <Link to="/contact" onClick={closeMenu}>
            Contact
          </Link>
        </nav>
      )}
    </header>
  );
};

export default Header;
